export default angular.module("views:mapping", [require("../../../../views").default]).run([
  "$templateCache",
  function ($templateCache) {
    $templateCache.put("/maps/map.html", require("bundle-text:./map.pug"));
    $templateCache.put("/maps/not-found.html", require("bundle-text:./not-found.pug"));
  },
]).name;
